import React from "react"

export default function Employees() {
  return (
    <symbol id="svg-employees" viewBox="0 0 36 36">
      <path
        d="M13 6C9.68 6 7 8.68 7 12C7 15.32 9.68 18 13 18C16.32 18 19 15.32 19 12C19 8.68 16.32 6 13 6ZM13 15C11.26 15 10 13.74 10 12C10 10.26 11.26 9 13 9C14.74 9 16 10.26 16 12C16 13.74 14.74 15 13 15Z"
        fill="currentColor"
      />
      <path
        d="M1 25C1 21.01 8.99 19 13 19C17.01 19 25 21.01 25 25V30H22V25C22 24.04 17.46 22 13 22C8.54 22 4 24.04 4 25V30H1V25Z"
        fill="currentColor"
      />
      <path
        d="M24.51 19.69C26.57 21.09 28 22.97 28 25.5V30H34V25.5C34 22.23 28.65 20.3 24.51 19.69Z"
        fill="currentColor"
      />
      <path
        d="M22 18C25.31 18 28 15.32 28 12C28 8.68 25.31 6 22 6C21.3 6 20.64 6.15 20.01 6.36C21.25 7.9 22 9.87 22 12C22 14.13 21.25 16.09 20.01 17.64C20.64 17.85 21.3 18 22 18Z"
        fill="currentColor"
      />
    </symbol>
  )
}
